
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAdmin } from '@/contexts/admin/AdminContext';

export const useAdminNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setIsAdminArea, setAdminSection } = useAdmin();

  // Update admin state based on current route
  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith('/admin');
    setIsAdminArea(isAdminRoute);
    
    if (isAdminRoute) {
      // Extract section from URL (e.g., /admin/users -> users)
      const section = location.pathname.split('/')[2] || 'dashboard';
      setAdminSection(section);
    }
  }, [location.pathname, setIsAdminArea, setAdminSection]);

  // Navigation helpers
  const navigateToAdminSection = (section: string) => {
    navigate(`/admin/${section}`);
    setAdminSection(section);
  };

  const exitAdmin = () => {
    navigate('/');
    setIsAdminArea(false);
  };

  return {
    navigateToAdminSection,
    exitAdmin,
    currentSection: location.pathname.split('/')[2] || 'dashboard'
  };
};

export default useAdminNavigation;
